import { Typography, Space, Divider } from 'antd';
import GlobalDatePreset from './GlobalDatePreset';
import GroupByTab from './GroupByTab';
import { DownloadCenterProvider } from '../../contexts/DownloadCenterContext';

const { Title } = Typography;

const DownloadCenter = () => {

  return (
    <DownloadCenterProvider>
      <Title level={4} style={{ marginTop: 0 }}>
        Download Center
      </Title>
      <Divider />
      <Space
        size={'large'}
        direction="vertical"
        style={{
          width: '100%',
          padding: '8px 0',
        }}
      >
        <GlobalDatePreset />
        <GroupByTab />
      </Space>
    </DownloadCenterProvider>
  );
};

export default DownloadCenter;
